var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"popover",staticClass:"jw-popover",class:_vm.cssClass,style:(_setup.style)},[_c('section',{staticClass:"jw-popover__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }